// All business times are Asia/Bangkok (UTC+7). The database stores naive DATETIME values
// ("YYYY-MM-DD HH:mm:ss") that are already Bangkok wall-clock time.
const BANGKOK_TZ = 'Asia/Bangkok';

const partsInBangkok = (date) => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: BANGKOK_TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date).reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});
  return parts;
};

// Current (or given) moment as a Bangkok "YYYY-MM-DD HH:mm:ss" string, ready for a MySQL DATETIME.
export const toBangkokSql = (value = new Date()) => {
  const p = partsInBangkok(value instanceof Date ? value : new Date(value));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
};

const hasTimezone = (value) => /([zZ]|[+-]\d{2}:?\d{2})$/.test(String(value));

// Parse a stored value to a Date. Naive strings are Bangkok wall-clock; strings with a zone are exact instants.
export const parseBangkok = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const text = String(value).trim().replace(' ', 'T');
  return new Date(hasTimezone(text) ? text : `${text}+07:00`);
};

export const formatBangkokTime = (value, options = { hour: '2-digit', minute: '2-digit', hour12: true }) => {
  const date = parseBangkok(value);
  if (!date || Number.isNaN(date.getTime())) return '-';
  return date.toLocaleTimeString('en-US', { ...options, timeZone: BANGKOK_TZ });
};

export const formatBangkokDateTime = (value) => {
  const date = parseBangkok(value);
  if (!date || Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-GB', {
    timeZone: BANGKOK_TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).replace(',', '');
};

export const bangkokDurationMinutes = (start, end) => {
  const s = parseBangkok(start);
  const e = parseBangkok(end);
  if (!s || !e) return 0;
  return Math.round((e - s) / 60000);
};
